module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CN",
    attrs: {
      "id": "_idParaDest-6"
    }
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "TOCFM"
  }, [_c('a', {
    attrs: {
      "href": "#/97808021495416#_idTextAnchor001"
    }
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('a', {
    attrs: {
      "href": "#/97808021495417#_idTextAnchor002"
    }
  }, [_vm._v("One")]), _vm._v(" – "), _c('span', {
    staticClass: "Character CharOverride-10"
  }, [_vm._v("西 ")]), _vm._v("– WEST")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/97808021495418#_idTextAnchor003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two")]), _vm._v(" – "), _c('span', {
    staticClass: "Character CharOverride-10"
  }, [_vm._v("南 ")]), _vm._v("– SOUTH")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/97808021495419#_idTextAnchor004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three")]), _vm._v(" – "), _c('span', {
    staticClass: "Character CharOverride-10"
  }, [_vm._v("东 ")]), _vm._v("– EAST")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/978080214954110#_idTextAnchor005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four")]), _vm._v(" – "), _c('span', {
    staticClass: "Character CharOverride-10"
  }, [_vm._v("北 ")]), _vm._v("– NORTH")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/978080214954111#_idTextAnchor006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five")]), _vm._v(" – "), _c('span', {
    staticClass: "Character CharOverride-10"
  }, [_vm._v("下 ")]), _vm._v("– DOWN")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/978080214954112#_idTextAnchor007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six")]), _vm._v(" – "), _c('span', {
    staticClass: "Character CharOverride-10"
  }, [_vm._v("上 ")]), _vm._v("– UP")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/978080214954113#_idTextAnchor008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Seven")]), _vm._v(" – "), _c('span', {
    staticClass: "Character CharOverride-10"
  }, [_vm._v("左 ")]), _vm._v("– LEFT")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/978080214954114#_idTextAnchor009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Eight")]), _vm._v(" – "), _c('span', {
    staticClass: "Character CharOverride-10"
  }, [_vm._v("右 ")]), _vm._v("– RIGHT")]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/978080214954115#_idTextAnchor010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC"
  }, [_c('span', {
    attrs: {
      "href": "#/978080214954116#_idTextAnchor011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")]), _vm._v(" on Citations")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2840cdf2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97808021495415.vue
// module id = 78
// module chunks = 0